import { render, staticRenderFns } from "./CreateEditBook.vue?vue&type=template&id=8bf8c0b6&scoped=true&"
import script from "./CreateEditBook.vue?vue&type=script&lang=js&"
export * from "./CreateEditBook.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditBook.vue?vue&type=style&index=0&id=8bf8c0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf8c0b6",
  null
  
)

export default component.exports